// SAP-Transparenz-Panel: eine einklappbare Karte, die exakt die Felder zeigt, die an SAP gehen
// (Wizards, Richtung "to SAP") bzw. aus SAP kamen (OrderDetail, Richtung "from SAP"). Verallgemeinert
// das fruehere showDefaults-Aufklappen aus NewOrderWizard zu einem geteilten Primitiv.
//
// Die Feldliste kommt vom Aufrufer (rows) — sie spiegelt den SapAdapter-Seam. Wenn die Feld-Matrix
// aus docs/plant-maintenance/sap-contract-requirements.md von den Beratern bestaetigt ist, kann das
// Panel spaeter direkt aus dieser Kontrakt-Tabelle rendern statt aus handgepflegten rows.
//
// children (optional) werden UNTER den Zeilen gerendert — die Wizards haengen dort ihre
// Auswahl-Steuerelemente (Auftragsart/Werk) ein, damit "Details aendern" wirklich aendern kann.
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTheme } from '../../../core/ui/ThemeContext';
import { Card } from './ui';

/**
 * @param {Array<{label: string, value: any}>} rows — Anzeige-Zeilen (bereits uebersetzt)
 * @param {string} showLabel — Toggle-Beschriftung im zugeklappten Zustand
 * @param {string} hideLabel — Toggle-Beschriftung im aufgeklappten Zustand
 * @param {string} [note] — gedaempfte Fussnote (z. B. "Diese Felder werden an SAP uebertragen.")
 * @param {boolean} [defaultOpen]
 * @param {React.ReactNode} [children] — optionale Steuerelemente unter den Zeilen
 */
function SapPayloadPanel({ rows, showLabel, hideLabel, note, defaultOpen = false, children }) {
  const { isDarkMode } = useTheme();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1 text-sm font-medium ${isDarkMode ? 'text-white/60' : 'text-slate-500'}`}
        aria-expanded={open}
      >
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />} {open ? hideLabel : showLabel}
      </button>
      {open && (
        <Card className="space-y-2 text-sm mt-2">
          {rows.filter((r) => r.value !== undefined && r.value !== null && r.value !== '').map((r) => (
            <div key={r.label} className="flex justify-between gap-3">
              <span className={isDarkMode ? 'text-white/60' : 'text-slate-500'}>{r.label}</span>
              <span className={`font-medium text-right break-all ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                {String(r.value)}
              </span>
            </div>
          ))}
          {children}
          {note && (
            <p className={`text-xs pt-1 ${isDarkMode ? 'text-white/40' : 'text-slate-400'}`}>{note}</p>
          )}
        </Card>
      )}
    </div>
  );
}

export default SapPayloadPanel;
